export interface RedsysFormPayload {
  Ds_SignatureVersion: string;
  Ds_MerchantParameters: string;
  Ds_Signature: string;
  actionUrl: string;
}

/** Envía el formulario POST a la pasarela Redsys (redirección al TPV). */
export function submitRedsysForm(formData: RedsysFormPayload): void {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = formData.actionUrl;
  form.style.display = "none";
  const fields = [
    { name: "Ds_SignatureVersion", value: formData.Ds_SignatureVersion },
    { name: "Ds_MerchantParameters", value: formData.Ds_MerchantParameters },
    { name: "Ds_Signature", value: formData.Ds_Signature },
  ];
  for (const { name, value } of fields) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }
  document.body.appendChild(form);
  form.submit();
}

const CONTRATAR_PAGO_CTX_KEY = "contratar_pago_ctx";

export function saveContratarPagoCtx(token: string, seguroId: number, pilotoId?: number): void {
  const payload: { token: string; seguroId: number; pilotoId?: number } = {
    token: token.trim(),
    seguroId,
  };
  if (typeof pilotoId === "number" && pilotoId >= 1) {
    payload.pilotoId = pilotoId;
  }
  sessionStorage.setItem(CONTRATAR_PAGO_CTX_KEY, JSON.stringify(payload));
}

export function loadContratarPagoCtx(): {
  token: string;
  seguroId: number;
  pilotoId?: number;
} | null {
  try {
    const raw = sessionStorage.getItem(CONTRATAR_PAGO_CTX_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { token?: string; seguroId?: number; pilotoId?: number };
    if (!parsed.token?.trim() || typeof parsed.seguroId !== "number" || parsed.seguroId < 1) {
      return null;
    }
    const out: { token: string; seguroId: number; pilotoId?: number } = {
      token: parsed.token.trim(),
      seguroId: parsed.seguroId,
    };
    if (typeof parsed.pilotoId === "number" && parsed.pilotoId >= 1) {
      out.pilotoId = parsed.pilotoId;
    }
    return out;
  } catch {
    return null;
  }
}
